export default class McleodStateSerializer {
  static serialize(data) {
    return {
      id: data.id,
      name: data.name,
    };
  }

  static deSerialize(data) {
    return {
      id: data.id,
      name: data.name,
    };
  }
}